export default __webpack_public_path__ + "static/media/Field-Guide.31fa5636.pdf";